
import axios from 'axios';
import Api from '../api/ApiUrl'
const config = {
  headers: {
      // Authorization: `Bearer ${Cookies.get('token')}`,
      role: 'admin'
  },
};
const API_URL = `${Api}/api/v1/apppermissions`;
export const getPermissions = async () => {
  const response = await axios.get(API_URL,config);
  return response.data.data.permissions;
};

export const getPermissionById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`,config);
  return response.data.data.permission;
};

export const createPermission = async (permissionData) => {
  const response = await axios.post(API_URL, permissionData,config);
  return response.data.data.permission;
};

export const updatePermission = async ({ id, ...permissionData }) => {
  const response = await axios.patch(`${API_URL}/${id}`, permissionData,config);
  return response.data.data.permission;
};


export const deletePermission = async (id) => {
  await axios.delete(`${API_URL}/${id}`,config);
};
